import { PropsWithChildren, useMemo } from 'react';

import { HeaderProps } from '../../lib/Header';

import { HeaderPropsContext } from './HeaderPropsContext';

export type HeaderPropsProviderProps = Partial<Pick<HeaderProps, 'supportedOpCos' | 'userDetails' | 'auth'>>;

export function HeaderPropsProvider({ children, supportedOpCos, userDetails, auth }: PropsWithChildren<HeaderPropsProviderProps>) {
  const ctx = useMemo(
    () => ({
      supportedOpCos,
      userDetails,
      auth,
    }),
    [supportedOpCos, userDetails, auth]
  );

  return <HeaderPropsContext.Provider value={ctx}>{children}</HeaderPropsContext.Provider>;
}
